/** Preserve a pending EstateFlow invitation only across the current login/2FA flow. */
const KEY = 'estateflow_pending_invite_code';

export function captureInviteCodeFromLocation() {
  const params = new URLSearchParams(window.location.search);
  const code = (params.get('invite_code') || params.get('code') || '').trim();
  if (code) sessionStorage.setItem(KEY, code);
  return code;
}

export function getPendingInviteCode() {
  return (sessionStorage.getItem(KEY) || '').trim();
}

export function clearPendingInviteCode() {
  sessionStorage.removeItem(KEY);
}
